import React from 'react';
import { Box, Typography, TextField, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StepPartySize = ({ partySize, setPartySize, minPersons, maxPersons, loadingConstraints }) => {
  const isValidAmount = partySize && (parseInt(partySize) >= minPersons && parseInt(partySize) <= maxPersons);
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
        {t('varausModal.stepPartySize.enterText')}
      </Typography>

      {loadingConstraints && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <CircularProgress size={20} />
          <Typography variant="body2" color="text.secondary">
            {t('varausModal.stepPartySize.loading')}
          </Typography>
        </Box>
      )}

      <TextField
        type="number"
        label={t('varausModal.stepPartySize.personAmount')}
        value={partySize}
        onChange={e => setPartySize(e.target.value)}
        inputProps={{ min: minPersons, max: maxPersons }}
        error={!isValidAmount}
        helperText={!isValidAmount ? `${t('varausModal.stepPartySize.mustBe')} ${minPersons} - ${maxPersons}` : `${minPersons} - ${maxPersons} ${t('varausModal.stepPartySize.persons')}`}
        fullWidth
        variant="outlined"
        disabled={loadingConstraints}
      />
    </Box>
  );
};

export default StepPartySize;
